import React from "react";

import { getTopic } from "~/components/KnowledgeCenterCard";

import Breadcrumbs from "~/components/Breadcrumbs";

import useGetBasePath from "~/hooks/useGetBasePath";
import { useTranslationContext } from "~/context/TranslationContext";

import { getTopicNameTranslation } from "~/utilities/helpers";

const handleTopicNameTranslation = (topic, topics, languageCode) => {
    const translatedName = getTopicNameTranslation(
        topic?.name,
        topics,
        languageCode,
    );

    let translatedTopic = topic;

    if (translatedName && topic) {
        translatedTopic = { ...topic, name: translatedName.translation };
    }

    return translatedTopic;
};

const addLanguageQueryParam = (activeCode, getBasePath) => {
    const url = getBasePath("knowledgeCenterBase")?.url || "";
    return `${url}?language=${activeCode}`;
};

const addTopicQueryParam = (slug, kcUrl) => {
    const param = slug ? `&topics=${slug}` : "";
    return `${kcUrl}${param}`;
};

const useKCArticleBreadcrumbs = (data) => {
    const {
        wpArticle: {
            title,
            articleTopics,
            primaryTopic: { primaryTopic },
        },
    } = data;

    const getBasePath = useGetBasePath();
    const { activeCode } = useTranslationContext();

    const articleTopic = getTopic(primaryTopic, articleTopics.nodes);

    const topic = handleTopicNameTranslation(
        articleTopic,
        articleTopics.nodes,
        activeCode,
    );

    const kcUrl = addLanguageQueryParam(activeCode, getBasePath);
    const kcLabel =
        getBasePath("knowledgeCenterBase")?.label || "Knowledge Center";

    return [
        {
            pathname: getBasePath("pagesBase")?.url || "/",
            crumbLabel: getBasePath("pagesBase")?.label || "Home",
        },
        {
            pathname: kcUrl,
            crumbLabel: kcLabel,
        },
        {
            pathname: addTopicQueryParam(topic?.slug, kcUrl),
            crumbLabel: topic?.name,
        },
        { crumbLabel: title },
    ];
};

const ArticleBreadcrumbs = ({ data }) => {
    const {
        wpArticle: {
            articleOptions: { breadcrumbsAtTop },
        },
    } = data;
    const breadcrumbs = useKCArticleBreadcrumbs(data);

    return (
        <Breadcrumbs
            backgroundColor={breadcrumbsAtTop ? "gray" : "white"}
            crumbs={breadcrumbs}
            noMarginBottom={breadcrumbsAtTop}
        />
    );
};

export default ArticleBreadcrumbs;
